import { constants } from '../constants/socketio.constants';

const defaultState = {
  io: undefined,
  connected: false
}

export default (state = defaultState, action = {}) => {
  switch (action.type) {
    case constants.SOCKETIO_CONNECT: { 
      return {
				...state,
				io: action.socket,
			}
		}
		case constants.SOCKETIO_DISCONNECT: {            
			return {
				...state,
				io: undefined,
			}
		}
    case constants.SOCKETIO_ON_CONNECT: { 
      return {
				...state,
				io: action.socket,
				connected: true,
			}
		}
		case constants.SOCKETIO_ON_DISCONNECT: {            
			return {
				...state,
				io: undefined,
				connected: false,
			}
		}
		default:
			return state;
	}
}